import { ModuleCommandEnum } from "@/types/enums/module-command.enum";
import { useTranslation } from "react-i18next";
import tw from "twin.macro";
import { getInProgressTranslation } from "./utils/get-in-progress-translation";
import { useAutoFitText } from "@/hooks/useAutoFitText";

function ProgressionStatusCard({
  children,
  currentAction,
}: {
  children: React.ReactNode;
  currentAction: ModuleCommandEnum;
}) {
  const { t: translator } = useTranslation();
  const label = translator(getInProgressTranslation(currentAction));

  // Same trick as in BottomSheet: a flex-1 min-w-0 wrapper gives the hook a
  // parent whose clientWidth matches the actual width allocated to the text
  // (otherwise the <p> itself is the flex item and the hook would measure
  // the full row, dots included).
  const { ref } = useAutoFitText<HTMLParagraphElement>({
    maxFontSize: 14,
    minFontSize: 10,
    deps: [label],
  });

  return (
    <div
      css={[
        tw`flex w-full items-stretch overflow-hidden`,
        tw`rounded-xl bg-modules-greenBase/10`,
        tw`rounded-xl bg-[rgb(59,146,213)]/10`,
        tw`min-h-[50px]`,
      ]}
    >
      <div css={[tw`flex min-w-0 flex-1 px-5 py-4 items-center`]}>
        <div tw="flex-1 min-w-0">
          <p
            ref={ref}
            css={[
              tw`font-normal text-[#3b92d5]`,
              tw`font-medium`,
              tw`tracking-[-0.02em]`,
            ]}
          >
            {label}
          </p>
        </div>
        <span tw="ml-2 flex w-[20px] text-[#2F8A4B] text-xl items-center justify-center shrink-0">
          <span className="dot">.</span>
          <span className="dot">.</span>
          <span className="dot">.</span>
        </span>
      </div>
      {children}
    </div>
  );
}

export default ProgressionStatusCard;
